import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import CommonNav from "../../main/CommonNav2";
import Footer from "../../main/Footer";

import BuddibleSocket from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";

const socket = new BuddibleSocket();
const util = new Utilities();

const _urls = {
  notice: "/notice/JS_notice_select.php", //nt
  carrierNotice: "/logistoryBoard/JS_postLogistorySelect.php", //pr
  qna: "/qa/JS_qa_select.php", //qa
  promotion: "/promotion/JS_promotion_select.php", //pr
};

let post_list = [];
let rowsPerPage = 21;
let page = 0;
let pageSize = 0;
let totalCount = 0;
let totalPageCount = 0;
let filters = {};
let isRequesting = false;

export default function PostList({}) {
  const { t, i18n } = useTranslation();
  const { post_type } = useParams();
  const [isPostLoad, setIsPostLoad] = useState(false);
  const [serverData, setServerData] = useState([]);
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const [carrierNoticeCategorize, setCarrierNoticeCategorize] = useState(null);
  const categorize = {
    notice: [
      { key: "NTA01", desc: t("post.categorize.notice.NTA01") },
      { key: "NTA02", desc: t("post.categorize.notice.NTA02") },
      { key: "NTA03", desc: t("post.categorize.notice.NTA03") },
      { key: "NTA04", desc: t("post.categorize.notice.NTA04") },
      { key: "NTA05", desc: t("post.categorize.notice.NTA05") },
    ],
    qna: [
      { key: "FJA0", desc: t("post.categorize.qna.FJA0") },
      { key: "FJA1", desc: t("post.categorize.qna.FJA1") },
      { key: "FJA2", desc: t("post.categorize.qna.FJA2") },
      { key: "FJA3", desc: t("post.categorize.qna.FJA3") },
      { key: "FJA4", desc: t("post.categorize.qna.FJA4") },
    ],
  };
  const SEARCH_WORD = useRef(); // all
  const SEARCH_LEVEL = useRef(); // notice, qna
  const SEARCH_TYPE = useRef(); // carrierNotice
  const SEARCH_COMP = useRef(); // carrierNotice

  useEffect(() => {
    i18n.changeLanguage(i18n.language);
  }, []);

  useEffect(() => {
    page = 0;
    setServerData([]);
    post_list = [];
    isRequesting = true;
    if (SEARCH_WORD.current) SEARCH_WORD.current.value = "";
    if (SEARCH_LEVEL.current) SEARCH_LEVEL.current.value = "";
    if (SEARCH_TYPE.current) SEARCH_TYPE.current.value = "";
    if (SEARCH_COMP.current) SEARCH_COMP.current.value = "";
    setIsPostLoad(true);
    if (post_type === "carrierNotice" && carrierNoticeCategorize === null) {
      let value = {
        categorize: [],
        compList: [],
      };
      SELECT_CARRIER_NOTICE_CATEGORIZE((res) => {
        value.categorize = res;
        SELECT_CARRIER_NOTICE_COMP_LIST((response) => {
          value.compList = response;
          setCarrierNoticeCategorize(value);
        });
      });
    }
    SELECT_POST_LIST();
  }, [post_type]);

  useEffect(() => {
    function changeSchedulePage() {
      //데이터 불러오기
      const scrollTop = document.documentElement.scrollTop; // 현재 스크롤 위치
      const maxScroll =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight; // 최대 스크롤 가능한 높이
      if (maxScroll - scrollTop < 300) {
        handleChangePage(page + 1);
      }
    }

    window.addEventListener("scroll", changeSchedulePage);
    return () => {
      window.removeEventListener("scroll", changeSchedulePage);
    };
  }, [page]);

  //페이지 이동
  function handleChangePage(val) {
    if (post_list.length === Number(pageSize) || isRequesting) return;

    isRequesting = true;
    setIsPostLoad(true);
    page = val;
    const currentScrollTop = document.documentElement.scrollTop;
    window.scrollTo(0, currentScrollTop);
    SELECT_POST_LIST();
  }

  function SELECT_CARRIER_NOTICE_CATEGORIZE(callback) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/logistoryBoard/JS_logistory_notice_type_full_name_code_select.php",
      msgID: msgID,
      data: {},
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["returnData"].length > 0) {
          callback && callback(newData["returnData"]);
        }
      }
    });
  }

  //선사 · 항공사 불러오기
  function SELECT_CARRIER_NOTICE_COMP_LIST(callback) {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/logistoryBoard/JS_logistory_bcomp_select.php",
      msgID: msgID,
      data: {},
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["returnData"].length > 0) {
          callback && callback(newData["returnData"]);
        }
      }
    });
  }

  function SELECT_POST_LIST() {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: _urls[post_type],
      msgID: msgID,
      data: {},
      take: rowsPerPage,
      skip: page * rowsPerPage,
      page: page + 1,
      pageSize: 5,
      sort: [],
      SEARCH_WORD: SEARCH_WORD.current ? SEARCH_WORD.current.value.trim() : "",
      SEARCH_LEVEL: SEARCH_LEVEL.current ? SEARCH_LEVEL.current.value : "",
      SEARCH_TYPE: SEARCH_TYPE.current ? SEARCH_TYPE.current.value : "",
      SEARCH_COMP: SEARCH_COMP.current ? SEARCH_COMP.current.value : "",
      ...filters,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          post_list =
            newData["returnData"].length > 0
              ? [...post_list, ...newData["returnData"]]
              : [];
          setServerData(post_list);
          pageSize = newData.pageSize;
          totalCount = parseInt(newData.pageSize, 10);
          totalPageCount =
            newData["returnData"].length > 0
              ? parseInt(
                  parseInt(newData.pageSize, rowsPerPage) / rowsPerPage,
                  rowsPerPage
                ) +
                (parseInt(newData.pageSize, rowsPerPage) % rowsPerPage > 0
                  ? 1
                  : 0)
              : 0;
          isRequesting = false;
          setIsPostLoad(false);
          setIsNeedUpdate(!isNeedUpdate);
        }
      }
    });
  }

  function actionSearch() {
    page = 0;
    setServerData([]);
    post_list = [];
    isRequesting = true;
    setIsPostLoad(true);
    SELECT_POST_LIST();
  }

  const dataList = React.useMemo(() => {
    return [...serverData];
  }, [serverData]);

  return (
    <>
      <CommonNav />
      <main>
        <section
          className="p-5 d-flex flex-column justify-content-center align-items-center position-relative"
          style={{
            background:
              "url(/images/gbts_carousel_2.jpg) 50% 10% / cover no-repeat",
            height: 520,
          }}
        >
          <div
            className="position-absolute w-100 h-100"
            style={{ background: "rgba(0,0,0,0.6)" }}
          />
          <div className="container">
            <div className="row m-0 p-0">
              <div className="col-lg-5 m-0 p-0 text-white">
                <p className="h3 font-weight-bold">
                  {t("post.main." + post_type + ".title")}
                </p>
                <p className="h5 mb-3">
                  {t("post.main." + post_type + ".desc")}
                </p>
              </div>
              <div className="col-lg-2" />
              <div className="col-lg-5 m-0 p-0">
                <div className="bg-white p-4 rounded-lg shadow-lg">
                  <div className="p-1">
                    <p className="h6 font-weight-900 mb-5 mr-3">
                      {t("post.msg.searchOnFreiscop")}
                    </p>
                    <div className="d-flex flex-row bg-light p-2 mb-2 rounded">
                      <input
                        type="text"
                        className="bg-transparent border-0 flex-fill"
                        placeholder={t("post.search")}
                        ref={SEARCH_WORD}
                        onKeyPress={(e) => {
                          if (e.charCode === 13) {
                            actionSearch();
                          }
                        }}
                      />
                      <button
                        className="p-0 px-1 border-0 text-freiscop bg-transparent"
                        onClick={actionSearch}
                      >
                        <i className="fa-solid fa-magnifying-glass" />
                      </button>
                    </div>
                    <div className="row m-0 p-0">
                      <div className="col-6 m-0 p-0 pr-1 pb-2">
                        <Link
                          to="/PostList/notice"
                          className={`btn btn-sm btn-outline-info ${
                            post_type === "notice" ? "bg-gbts text-white" : ""
                          } font-size-09 w-100`}
                        >
                          {t("post.main.notice.title")}
                        </Link>
                      </div>
                      <div className="col-6 m-0 p-0 pb-2 pl-1">
                        <Link
                          to="/PostList/carrierNotice"
                          className={`btn btn-sm btn-outline-info ${
                            post_type === "carrierNotice"
                              ? "bg-gbts text-white"
                              : ""
                          } font-size-09 w-100`}
                        >
                          {t("post.main.carrierNotice.title")}
                        </Link>
                      </div>
                      <div className="col-6 m-0 p-0 pr-1">
                        <Link
                          to="/PostList/qna"
                          className={`btn btn-sm btn-outline-info ${
                            post_type === "qna" ? "bg-gbts text-white" : ""
                          } font-size-09 w-100`}
                        >
                          {t("post.main.qna.title")}
                        </Link>
                      </div>
                      <div className="col-6 m-0 p-0 pl-1">
                        <Link
                          to="/PostList/promotion"
                          className={`btn btn-sm btn-outline-info ${
                            post_type === "promotion"
                              ? "bg-gbts text-white"
                              : ""
                          } font-size-09 w-100`}
                        >
                          {t("post.main.promotion.title")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="container py-3">
          {post_type !== "promotion" && (
            <div className="d-flex flex-row justify-content-end px-2 mb-1">
              {post_type !== "carrierNotice" && (
                <select
                  className="border rounded-sm py-2 px-3"
                  ref={SEARCH_LEVEL}
                  onChange={actionSearch}
                >
                  <option value="">--{t("post.filter")}--</option>
                  {categorize[post_type].map((opt) => {
                    return (
                      <option key={opt.key} value={opt.key}>
                        {opt.desc}
                      </option>
                    );
                  })}
                </select>
              )}
              {post_type === "carrierNotice" && carrierNoticeCategorize && (
                <>
                  <select
                    className="border rounded-sm py-2 px-3 mr-1"
                    ref={SEARCH_TYPE}
                    onChange={actionSearch}
                  >
                    <option value="">--{t("post.filter")}--</option>
                    {carrierNoticeCategorize["categorize"].map((opt) => {
                      return (
                        <option key={opt["SmallType"]} value={opt["SmallType"]}>
                          {opt["FullName"]}
                        </option>
                      );
                    })}
                  </select>
                  <select
                    className="border rounded-sm py-2 px-3 ml-1"
                    ref={SEARCH_COMP}
                    onChange={actionSearch}
                  >
                    <option value="">--{t("post.compFilter")}--</option>
                    {carrierNoticeCategorize["compList"].map((opt, index) => {
                      return (
                        <option key={index} value={opt["prBCOMPNM"]}>
                          {opt["prBCOMPNM"]}
                        </option>
                      );
                    })}
                  </select>
                </>
              )}
            </div>
          )}
          <div className="row m-0 p-0">
            {dataList.length > 0 &&
              dataList.map((data) => {
                const IDX = data.ntIDX || data.qaIDX || data.prIDX;
                const TITLE = data.ntTITLE || data.qaTITLE || data.prTITLE;
                const CreateDate = util.getDateToFormat(
                  data.ntCreateDate || data.qaCreateDate || data.prCreateDate,
                  "YYYY-MM-DD"
                );
                const sName = data.sName;

                let prLOGO;
                if (data.prLOGO) {
                  prLOGO = data.prLOGO.split("?")[0];
                }
                return (
                  <div
                    key={IDX}
                    className="col-6 col-xl-4 p-2"
                    style={{ minHeight: 180 }}
                  >
                    <Link
                      to={`/PostDetail/${post_type}/${IDX}`}
                      className="d-block h-100 p-3 bg-white border rounded-lg shadow-sm cursor_pointer cursor_pointer_bg_light"
                    >
                      <div className="h-100 d-flex flex-column justify-content-between">
                        <div>
                          {post_type === "carrierNotice" && (
                            <div className="d-flex flex-row align-items-center mb-1">
                              <div
                                className="d-inline-block mr-2 rounded-lg"
                                style={{
                                  minWidth: 25,
                                  width: 25,
                                  height: 25,
                                  background: `url(${prLOGO})50% 50%/contain rgb(250,250,250) no-repeat`,
                                }}
                              >
                                {!prLOGO && (
                                  <div className="w-100 h-100 rounded bg-blue-light d-flex flex-row justify-content-center align-items-center">
                                    <span className="font-size-06">LOGO</span>
                                  </div>
                                )}
                              </div>
                              <p className="d-inline-block">
                                {data.prBCOMPNM ||
                                  t("main.shipCompNotice.compName")}
                              </p>
                            </div>
                          )}
                          <div>
                            {post_type !== "carrierNotice" && (
                              <p className="mb-1 d-inline-block px-2 text-white bg-freiscop font-size-09">
                                {sName}
                              </p>
                            )}
                            <p className="h6 mb-0 font-weight-bold">{TITLE}</p>
                          </div>
                        </div>
                        <div className="d-flex flex-row justify-content-between font-size-09">
                          {post_type === "carrierNotice" ? (
                            <p>
                              <i className="icon-inbox-alt mr-1" />
                              {sName}
                            </p>
                          ) : (
                            <div />
                          )}
                          <p>
                            <i className="icon-calendar-empty mr-1" />
                            {CreateDate}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}

            {dataList.length === 0 && !isPostLoad && (
              <div className="col-12 m-0 p-2">
                <div className="row m-0 p-0">
                  <div className="col-12 w-100 m-0 p-0 bg-light rounded p-5 h6 text-center font-weight-bold text-secondary">
                    {t("commonMSG.noData")}
                  </div>
                </div>
              </div>
            )}

            {isPostLoad && (
              <div className="col-12 rounded p-5 h6 text-center bg-light mt-3">
                <div className="d-flex justify-content-center">
                  <div className="spinner-grow text-secondary" role="status" />
                </div>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
